<template>
  <div class="project-settings-template">
    <AppSectionHero
      title="Permission"
      :subtitle="`Manage the working permission setup template for ${applicationLabel}.`"
      :show-refresh="false"
    />

    <CCard class="border-0 shadow-sm template-shell">
      <CCardBody class="p-4">
        <div class="template-shell__eyebrow">Project Template</div>
        <div class="template-shell__title">Permission Settings</div>
        <div class="template-shell__copy">Use this filled template page as the baseline for user access, role rules, assignments, and permission matrix setup.</div>

        <div class="template-grid">
          <div class="template-card">
            <div class="template-card__title">Manage Users</div>
            <div class="template-card__copy">Start with account access and workspace membership.</div>
            <ul class="template-list">
              <li>Review active accounts</li>
              <li>Confirm who belongs to the workspace</li>
              <li>Use this as the starting point for access cleanup</li>
            </ul>
            <button class="primary-btn template-card__button" @click="$router.push('/accounts/directory')">
              <CIcon name="cil-people" />
              Open MCA Accounts
            </button>
          </div>

          <div class="template-card">
            <div class="template-card__title">Roles & Permissions</div>
            <div class="template-card__copy">Define which roles can access drafting, review, translation, and reporting functions.</div>
            <ul class="template-list">
              <li>Map roles to screens and actions</li>
              <li>Keep admin, committee, and user scopes clear</li>
              <li>Use the matrix as the permission baseline</li>
            </ul>
            <button class="primary-btn template-card__button" @click="$router.push('/security/permissions/matrix')">
              <CIcon name="cil-lock-locked" />
              Open MCA Matrix
            </button>
          </div>

          <div class="template-card">
            <div class="template-card__title">Audit Explorer</div>
            <div class="template-card__copy">Review authentication, account, and permission events recorded for the MCA workspace.</div>
            <ul class="template-list">
              <li>Inspect recent access events</li>
              <li>Confirm permission changes</li>
              <li>Use it for security review</li>
            </ul>
            <button class="primary-btn template-card__button" @click="$router.push('/security/audit')">
              <CIcon name="cil-list-rich" />
              Open Audit Explorer
            </button>
          </div>

          <div class="template-card">
            <div class="template-card__title">Permission Matrix</div>
            <div class="template-card__copy">Open the lower-level matrix when you need to verify exact route and action coverage.</div>
            <ul class="template-list">
              <li>Audit route visibility</li>
              <li>Check fine-grained access rules</li>
              <li>Use it for final permission validation</li>
            </ul>
            <button class="secondary-btn template-card__button" @click="$router.push('/security/permissions/matrix')">
              <CIcon name="cil-grid" />
              Open Matrix Template
            </button>
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import AppSectionHero from '@/projects/components/layout/AppSectionHero'

export default {
  name: 'ProjectSettingsPermission',
  components: { AppSectionHero },
  computed: {
    applicationLabel() {
      return this.$route.params.application || 'this project'
    }
  }
}
</script>

<style scoped lang="scss">
@import "../shared/workspace-consistency.scss";

@include workspace-page-frame("project-settings-template");
@include workspace-button-system;

.template-shell {
  border-radius: 22px;
}

.template-shell__eyebrow {
  color: #8c1515;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.template-shell__title {
  color: #223045;
  font-size: 1.22rem;
  font-weight: 800;
}

.template-shell__copy {
  color: #66758a;
  line-height: 1.6;
  margin-top: 6px;
}

.template-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  margin-top: 20px;
}

.template-card {
  background: linear-gradient(180deg, #fffefc 0%, #ffffff 100%);
  border: 1px solid #e9edf3;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
}

.template-card__title {
  color: #223045;
  font-size: 1rem;
  font-weight: 800;
}

.template-card__copy {
  color: #66758a;
  line-height: 1.6;
}

.template-list {
  color: #4a596d;
  margin: 0;
  padding-left: 18px;
}

.template-list li + li {
  margin-top: 6px;
}

.template-card__button {
  align-self: flex-start;
  margin-top: auto;
}

@media (max-width: 768px) {
  .template-card__button {
    width: 100%;
  }
}
</style>
